// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"style__modalBody__KFv37","modalButtons":"style__modalButtons__uKXN3"};